export default function Usuarios() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Gestión de Usuarios</h2>
      <p>Administra usuarios, activa/inactiva y cambia contraseñas.</p>
    </div>
  );
}
